import React, { Component } from 'react';
import Modal from 'react-modal';
import './MediaModal.css';

const customStyles = {
    content: {
        overflow: 'hidden',
        width: '80%',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        maxHeight: '95vh',
    }
};

export default class MediaModal extends Component {
    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        Modal.setAppElement('body');
    }

    render() {
        return (
            <Modal
                style={customStyles}
                isOpen={this.props.isOpen}
                shouldCloseOnOverlayClick
                onRequestClose={this.props.onRequestClose}>
                {this.props.displayMode == ModalType.VIDEO &&
                    <figure className="video">
                        <div className="img-flow ratio-16-9">
                            {this.props.localVideoUrl &&
                                <video controls poster={this.props.imageUrl} src={this.props.localVideoUrl}></video>
                            }
                            {!this.props.localVideoUrl && this.props.embedCode &&
                                <div dangerouslySetInnerHTML={{ __html: this.props.embedCode }} />
                            }
                        </div>
                    </figure>}
                {this.props.displayMode == ModalType.IMAGE &&
                    <figure >
                        <div className="img-flow ratio-16-9">
                            <img src={this.props.imageUrl} />
                        </div>
                    </figure>}
                {this.props.displayMode == ModalType.FORM &&
                    <iframe src={this.props.formUrl} width="100%" height="200">
                        <div className="loader--full-screen">
                            <div className="loader__icon"/>
                        </div>
                    </iframe>}
            </Modal>
        );
    }
}

export const ModalType = {
    VIDEO: 'video',
    IMAGE: 'image',
    FORM: 'form'
}